import { useContext, type JSX } from 'react';
import { ActiveDatabaseContext } from '../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

interface IProps {
  children: (databaseName: string | null) => JSX.Element;
}

/**
Komponent vars children är en funktion av databasnamnet i aktuell route.

Vissa routes (t.ex. startsidan) har ingen aktuell databas. Då är databasnamnet null.

Det finns även en hoc variant (withActiveDatabaseName) som använder den här komponenten.
**/
const ActiveDatabaseName = (props: IProps) => {
  const dbContext = useContext(ActiveDatabaseContext);
  return props.children(dbContext.activeDatabase);
};

export default ActiveDatabaseName;
